import { render, staticRenderFns } from "./SurveyPreview.vue?vue&type=template&id=3859205c&"
import script from "./SurveyPreview.vue?vue&type=script&lang=js&"
export * from "./SurveyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SurveyPreview.vue"
export default component.exports